const IntentionGraphic = () => {
  return (
    <div style={{ height: 'auto', width: '100%', maxWidth: '334px', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '0', minHeight: '0' }}>
      <svg viewBox="0 0 334 278" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: 'auto' }}>
        {/* <rect width="324" height="261" fill="#1E1E1E"/> */}
        <circle cx="194" cy="139" r="139" fill="url(#paint0_linear_0_1)"/>
        <circle cx="139" cy="139" r="139" fill="url(#paint1_linear_0_1)"/>
        <text fill="white" fontFamily="Poiret One" fontSize="24" letterSpacing="0em">
          <tspan x="126" y="82" textAnchor="end">people</tspan>
          <tspan x="126" y="112" textAnchor="end">places</tspan>
          <tspan x="126" y="142" textAnchor="end">things</tspan>
          <tspan x="126" y="172" textAnchor="end">information</tspan>
          <tspan x="126" y="202" textAnchor="end">time</tspan>
        </text>
        <text fill="white" fontFamily="Poiret One" fontSize="24" letterSpacing="0em">
          <tspan x="204" y="82">sheltered</tspan>
          <tspan x="204" y="112">defined</tspan>
          <tspan x="204" y="142">contained</tspan>
          <tspan x="204" y="172">conveyed</tspan>
          <tspan x="204" y="202">recorded</tspan>
        </text>
        <text fill="#F5AA0D" fontWeight="bold" fontSize="24" letterSpacing="0em">
          <tspan x="148.141" y="142">are</tspan>
        </text>
        <defs>
          <linearGradient id="paint0_linear_0_1" x1="334" y1="139" x2="52" y2="139" gradientUnits="userSpaceOnUse">
            <stop offset="0.5" stopColor="#595959" stopOpacity="1"/>
            <stop offset="0.5" stopColor="white" stopOpacity="0"/>
          </linearGradient>
          <linearGradient id="paint1_linear_0_1" x1="0" y1="139" x2="278" y2="139" gradientUnits="userSpaceOnUse">
            <stop offset="0.5" stopColor="#F5AA0D"/>
            <stop offset="0.5" stopColor="white" stopOpacity="0"/>
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

const IdentificationGraphic = () => {
  return (
    <div style={{ height: 'auto', width: '100%', maxWidth: '424px', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '0', minHeight: '0' }}>
      <svg viewBox="0 0 424 180" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: 'auto' }}>
        {/* <rect width="424" height="180" fill="#1E1E1E"/> */}
        <circle cx="333.028" cy="90" r="90" fill="#F5AA0D"/>
        <circle cx="89.7902" cy="90" r="90" fill="#595959" fillOpacity="1"/>
        {/* <text fill="white" fontSize="14" letterSpacing="0em"><tspan x="305.955" y="31.4">dreams</tspan><tspan x="313.461" y="73.4">place</tspan><tspan x="293.787" y="115.4">technology</tspan><tspan x="300.056" y="157.4">economy</tspan></text>
        <text fill="white" fontSize="14" letterSpacing="0em"><tspan x="58.8398" y="31.4">thoughts</tspan><tspan x="68.5264" y="73.4">space</tspan><tspan x="60.6172" y="115.4">material</tspan><tspan x="52.8447" y="157.4">efficiency</tspan></text>
        <text fill="#F5AA0D" fontFamily="Poiret One" fontSize="24" letterSpacing="0em"><tspan x="191.593" y="99.048">and</tspan></text> */}
        <text fill="white" fontFamily="Poiret One" fontSize="24" letterSpacing="0em">
          <tspan x="270" y="53">dreams</tspan>
          <tspan x="260" y="83">place</tspan>
          <tspan x="260" y="113">technology</tspan>
          <tspan x="273" y="143">economy</tspan>
        </text>
        <text fill="white" fontFamily="Poiret One" fontSize="24" letterSpacing="0em">
          <tspan x="67" y="53">thoughts</tspan>
          <tspan x="105" y="83">space</tspan>
          <tspan x="82" y="113">material</tspan>
          <tspan x="52.8447" y="143">efficiency</tspan>
        </text>
        {/* <text fill="#F5AA0D" fontFamily="Poiret One" fontSize="24" letterSpacing="0em"><tspan x="191.593" y="99.048">and</tspan></text> */}
        <text fill="#F5AA0D" fontWeight="bold" fontSize="24" letterSpacing="0em"><tspan x="191.593" y="99.048">and</tspan></text>
      </svg>
    </div>
  );
};

const IntegrationGraphic = () => {
  return (
    <div style={{ height: 'auto', width: '100%', maxWidth: '310px', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '0', minHeight: '0' }}>
      <svg viewBox="0 0 310 310" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: 'auto' }}>
        <circle cx="155" cy="85" r="85" fill="#595959" fillOpacity="0.65"/>
        <circle cx="225" cy="155" r="85" fill="#595959" fillOpacity="0.65"/>
        <circle cx="155" cy="225" r="85" fill="#595959" fillOpacity="0.65"/>
        <circle cx="85" cy="155" r="85" fill="#595959" fillOpacity="0.65"/>
        {/* <text fill="white" style={{"whiteSpace": "pre"}}  fontSize="14" letterSpacing="0em"><tspan x="19" y="141.4">industry</tspan></text>
        <text fill="white" style={{"whiteSpace": "pre"}}  fontSize="14" letterSpacing="0em"><tspan x="115" y="217.9">quality</tspan><tspan x="123" y="238.9">size</tspan><tspan x="123" y="259.9">cost</tspan></text>
        <text fill="white" style={{"whiteSpace": "pre"}}  fontSize="14" letterSpacing="0em"><tspan x="217.229" y="141.4">site</tspan></text>
        <text fill="white" style={{"whiteSpace": "pre"}}  fontSize="14" letterSpacing="0em"><tspan x="115" y="21.4">needs</tspan><tspan x="115" y="42.4">wants</tspan><tspan x="112" y="63.4">budget</tspan></text> */}
        <text fill="white" style={{"whiteSpace": "pre"}} fontFamily="Poiret One" fontSize="24" letterSpacing="0em">
          <tspan x="13" y="158">industry</tspan>
        </text>
        <text fill="white" style={{"whiteSpace": "pre"}} fontFamily="Poiret One" fontSize="24" letterSpacing="0em">
          <tspan textAnchor="middle" x="155" y="248">quality</tspan>
          <tspan textAnchor="middle" x="155" y="269">size</tspan>
          <tspan textAnchor="middle" x="155" y="290">cost</tspan></text>
        <text fill="white" style={{"whiteSpace": "pre"}} fontFamily="Poiret One" fontSize="24" letterSpacing="0em">
          <tspan x="245" y="160">site</tspan>
        </text>
        <text fill="white" style={{"whiteSpace": "pre"}} fontFamily="Poiret One" fontSize="24" letterSpacing="0em">
          <tspan textAnchor="middle" x="155" y="28">needs</tspan>
          <tspan textAnchor="middle" x="155" y="49">wants</tspan>
          <tspan textAnchor="middle" x="155" y="70">budget</tspan>
        </text>
      </svg>
    </div>
  )
}

const ImplementationGraphic = () => {
  return (
    <div style={{ height: 'auto', width: '100%', maxWidth: '442px', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '0', minHeight: '0' }}>
      <svg viewBox="0 0 442 325" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: 'auto' }}>
        {/* <rect width="442" height="325" fill="#1E1E1E"/> */}
        <path d="M 162.5,0
                 a 162.5,162.5 0 1,0 0,325
                 Z"
              fill="#595959"
        />
        {/* <path d="M325 162.5C325 252.246 252.246 325 162.5 325C72.7537 325 0 252.246 0 162.5C0 72.7537 72.7537 0 162.5 0C252.246 0 325 72.7537 325 162.5Z" fill="url(#paint0_linear_0_1)"/> */}
        {/* 
        <text fill="white" style={{"whiteSpace": "pre"}} fontFamily="Poppins" fontSize="14" letterSpacing="0em">
          <tspan x="69.6738" y="55.4">constraints</tspan>
          <tspan x="94.707" y="97.4">defined</tspan>
          <tspan x="66.6797" y="139.4">established</tspan>
          <tspan x="90.4004" y="202.4">minimal</tspan>
          <tspan x="85.8887" y="244.4">beautiful</tspan>
          <tspan x="80.5977" y="286.4">impactful</tspan>
        </text>
        <text fill="#F5AA0D" style={{"whiteSpace": "pre"}} fontFamily="Poppins" fontSize="14" letterSpacing="0em">
          <tspan x="225" y="55.4">catalysts for creativity</tspan>
          <tspan x="225" y="97.4">not preconceived</tspan>
          <tspan x="225" y="139.4">expected to change</tspan>
          <tspan x="225" y="202.4">essential</tspan>
          <tspan x="225" y="244.4">transcending fashion</tspan>
          <tspan x="225" y="286.4">environmentally sensitive</tspan>
        </text>
        <text fill="#F5AA0D" style={{"whiteSpace": "pre"}} fontFamily="Poiret One" fontSize="24" letterSpacing="0em">
          <tspan x="172.953" y="247.048">yet</tspan>
        </text>
        <text fill="#F5AA0D" style={{"whiteSpace": "pre"}} fontFamily="Poiret One" fontSize="24" letterSpacing="0em">
          <tspan x="172.953" y="99.048">yet</tspan>
        </text>
        */}
        <text fill="white" fontFamily="Poiret One" fontSize="24" letterSpacing="0em">
          <tspan x="150" y="88" textAnchor="end">constraints</tspan>
          <tspan x="150" y="118" textAnchor="end">defined</tspan>
          <tspan x="150" y="148" textAnchor="end">established</tspan>
          <tspan x="150" y="200" textAnchor="end">minimal</tspan>
          <tspan x="150" y="230" textAnchor="end">beautiful</tspan>
          <tspan x="150" y="260" textAnchor="end">impactful</tspan>
        </text>
        <text fill="#595959" fontSize="18" letterSpacing="0em">
          <tspan x="225" y="88">catalysts for creativity</tspan>
          <tspan x="225" y="118">not preconceived</tspan>
          <tspan x="225" y="148">expected to change</tspan>
          <tspan x="225" y="200">essential</tspan>
          <tspan x="225" y="230">transcending fashion</tspan>
          <tspan x="225" y="260">environmentally sensitive</tspan>
        </text>
        <text fill="#F5AA0D" fontWeight="bold" fontSize="24" letterSpacing="0em">
          <tspan x="175" y="118">yet</tspan>
        </text>
        <text fill="#F5AA0D" fontWeight="bold" fontSize="24" letterSpacing="0em">
          <tspan x="175" y="230">yet</tspan>
        </text>
        <defs>
          <linearGradient id="paint0_linear_0_1" x1="0" y1="0" x2="442" y2="325" >
            <stop offset="0" stopColor="#595959" stopOpacity="1"/>
            <stop offset="1" stopColor="#595959" stopOpacity="1"/>
          </linearGradient>
        </defs>
      </svg>
    </div>
  )
}

const WhoGraphic = () => {
  return (
    <div style={{ height: 'auto', width: '100%', maxWidth: '360px', display: 'flex', justifyContent: 'center', alignItems: 'start', minWidth: '0', minHeight: '0' }}>
      <svg viewBox="0 0 360 360" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: 'auto' }}>
        {/* <rect width="359" height="440" fill="#1E1E1E"/> */}
        {/* <text fill="#473D27" fontSize="16" letterSpacing="0em"><tspan x="0" y="379.2">*Specialty consultants related to acoustics , audio/visual, </tspan><tspan x="0" y="397.2">communications, cost estimating, food service, indoor air </tspan><tspan x="0" y="415.2">quality, security, smart home, surveying, testing + </tspan><tspan x="0" y="433.2">engineering, traffic, and value engineering.</tspan></text> */}
        {/* <path d="M107 213.5C107 243.047 83.0472 267 54 267C23.9528 267 0 243.047 0 213.5C0 183.953 23.9528 160 54 160C83.0472 160 107 183.953 107 213.5Z" fill="#F5AA0D"/> */}
        <circle cx="180" cy="184" r="120" fill="#F5AA0D" opacity="1"/>  // architect
        <circle cx="180" cy="54" r="54" fill="#595959" opacity="1"/>  // structural engineer
        <circle cx="78" cy="104" r="54" fill="#595959" opacity="1"/>  // electrical engineer
        <circle cx="282" cy="104" r="54" fill="#595959" opacity="1"/>  // civil engineer
        <circle cx="54" cy="214" r="54" fill="#595959" opacity="1"/>  // mechanical engineer
        <circle cx="306" cy="214" r="54" fill="#595959" opacity="1"/>  // landscape architect
        <circle cx="124" cy="301" r="54" fill="#595959" opacity="1"/>  // plumbing engineer
        <circle cx="236" cy="301" r="54" fill="#595959" opacity="1"/>  // specialty consultants
        <text fill="white" fontSize="24" fontWeight="bold" letterSpacing="0em">
          <tspan textAnchor="middle" x="180" y="190">architect</tspan>
        </text>
        <text fill="white" fontFamily="Poiret One" fontSize="20" letterSpacing="0em">
          <tspan textAnchor="middle" x="180" y="50">structural</tspan><tspan textAnchor="middle" x="180" y="68">engineer</tspan>
        </text>
        <text fill="white" fontFamily="Poiret One" fontSize="20" letterSpacing="0em">
          <tspan textAnchor="middle" x="282" y="100">civil</tspan><tspan textAnchor="middle" x="282" y="118">engineer</tspan>
        </text>
        <text fill="white" fontFamily="Poiret One" fontSize="20" letterSpacing="0em">
          <tspan textAnchor="middle" x="306" y="210">landscape</tspan><tspan textAnchor="middle" x="306" y="228">architect</tspan>
        </text>
        <text fill="white" fontFamily="Poiret One" fontSize="20" letterSpacing="0em">
          <tspan textAnchor="middle" x="236" y="295">specialty</tspan><tspan textAnchor="middle" x="238" y="313">consultants*</tspan>
        </text>
        <text fill="white" fontFamily="Poiret One" fontSize="20" letterSpacing="0em">
          <tspan textAnchor="middle" x="124" y="295">plumbing</tspan><tspan textAnchor="middle" x="124" y="313">engineer</tspan>
        </text>
        <text fill="white" fontFamily="Poiret One" fontSize="20" letterSpacing="0em">
          <tspan textAnchor="middle" x="54" y="210">mechanical</tspan><tspan textAnchor="middle" x="54" y="228">engineer</tspan>
        </text>
        <text fill="white" fontFamily="Poiret One" fontSize="20" letterSpacing="0em">
          <tspan textAnchor="middle" x="78" y="100">electrical</tspan><tspan textAnchor="middle" x="78" y="118">engineer</tspan>
        </text>
      </svg>
    </div>
  );
};

export { IntentionGraphic, IdentificationGraphic, IntegrationGraphic, ImplementationGraphic, WhoGraphic };